const NAME = 'taskList';
export default { NAME };
